import { useNavigate, useLocation, useParams } from 'react-router-dom';

function withRouter(Component) {
    function ComponentWithRouterProp(props) {
        let location = useLocation();
        let navigate = useNavigate();
        let params = useParams();
        const push = (obj) => {
            console.log(obj);
            if (obj && obj.pathname)
                navigate(obj.pathname, obj.state);
        }
        const goBack = () =>{
            navigate(-1);
        }
        return <Component {...props} history={{ location, push, params,goBack }} />;
    }
    return ComponentWithRouterProp;
}
export default withRouter;
